import { Dialog } from 'primereact/dialog';
import React, { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DateTemplate } from '../../../../components/dateTemplate/DateTemplate';
import '../recalculation.scss';
import { useGetRecalculationJobLogsQuery } from '../recalculationSlice';

type LogsProps = {
    requestId: number;
    closeLogsDialog: (message: boolean) => void;
    showLogsDialog: boolean;
};
export const RecalculationJobLogs = ({ requestId, closeLogsDialog, showLogsDialog }: LogsProps) => {
    const [jobLogs, setJobLogs] = React.useState<any>([]);
    const { data: LogsData, refetch } = useGetRecalculationJobLogsQuery(
        { calculationRequestId: requestId },
        { skip: !requestId }
    );
    useEffect(() => {
        if (LogsData?.data.length > 0) {
            const data: any = LogsData?.data.map((element: any) => {
                return {
                    "calculation_request_log_id": element.calculation_request_log_id,
                    "log_Date": new Date(element.log_date),
                    "log_time": element.log_time,
                    "log_description": element.log_description
                };
            });
            setJobLogs(data);
        }
    }, [LogsData]);
    const dateBodyTemplate = (rowData: any) => {
        return DateTemplate(rowData.log_Date);
    };
    const dateFilterTemplate = (options: any) => {
        return <Calendar value={options.value} onChange={(e: any) => dateOnchanges(e, options)}
            dateFormat="mm/dd/yy"
            placeholder="dd/mm/yy"
            mask="99/99/9999"
            showIcon
            className="custom-calendar" />;
    };
    const dateOnchanges = (e: any, options: any) => {
        options.filterCallback(e.value, options.index);
    }
    const hideLogsDialog = () => {
        closeLogsDialog(true);
        setJobLogs([]);
    };
    const discriptiontemplate = (rowData: any) => {
        return <div className="description-cell" title={rowData.log_description}>
            {rowData.log_description}
        </div>
    };
    return (
        <Dialog
            visible={showLogsDialog}
            style={{ width: '900px' }}
            modal
            className="p-fluid disputeModal ms-2"
            onHide={hideLogsDialog}
        >
            <DataTable
                stripedRows
                className="RecalculationJobsTable ms-1 mt-1"
                value={jobLogs}
                dataKey="scorecard_window_comment_id"
                scrollable
                scrollHeight="600px"
                rows={10}
                rowsPerPageOptions={[10, 15, 25, 50]}
                paginator={jobLogs?.length > 5}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                emptyMessage=" No logs found. "
            >
                <Column
                    header="Start Date"
                    field="log_date"
                    style={{ width: '10px' }}
                    sortable
                    sortField="log_date"
                    body={dateBodyTemplate}
                    filterField="log_date" dataType="date" filter filterElement={dateFilterTemplate}
                />
                <Column
                    header="Start Time"
                    field="log_time"
                    style={{ width: '10px' }}
                    sortable
                    sortField="log_time"
                    filter filterPlaceholder="Search by Time"
                />
                <Column
                    header="Description"
                    field="log_description"
                    style={{ minWidth: '590px', maxWidth: '800px' }}
                    sortable
                    sortField="log_description"
                    filter filterPlaceholder="Search by description"
                    body={discriptiontemplate}
                />

            </DataTable>
            <div className="flexButtons mt-2">
                <Button
                    label="Cancel"
                    onClick={hideLogsDialog}
                    className="me-2 btn-secondary w-auto"
                />
                <Button
                    label="Refresh"
                    className="w-auto btn-primary"
                    onClick={() => refetch()}
                />
            </div>
        </Dialog>
    );
};
